import Swiper, { Navigation, EffectFade } from "swiper";
//import 'swiper/css';

(function () {
  /* Variables placed inside of this function will be considered private */
  Swiper.use([Navigation, EffectFade]);
  /* You won't see privateVar in global scope */
  const swipers = document.querySelectorAll(".swiper-custom");

  swipers.forEach((s) => {
    let swp;
    if (s.dataset.full) {
      swp = new Swiper(s, {
        slidesPerView: "auto",
        effect: "fade",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    } else {
      swp = new Swiper(s, {
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
          "@0.00": {
            slidesPerView: 1.5,
          },
          "@0.75": {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          "@1.25": {
            slidesPerView: 3,
            spaceBetween: 28,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }

    // Check if it has custom nav
    if (s.dataset.customNav) {
      let customNav = document.querySelector(`#${s.dataset.customNav}`);
      let links = customNav.querySelectorAll("[data-nav-link]");
      var slides = s.querySelectorAll(".swiper-slide");
      var slideArray = Array.prototype.slice.call(slides);

      links.forEach((l, i) => {
        l.onclick = (e) => {
          e.preventDefault();

          // get the slide index by using data-custom-nav-slide
          //data-custom-nav-slideco
          for (i = 0; i < slideArray.length; i++) {
            if (
              slideArray[i].dataset.customNavSlide ==
              l.getAttribute("href").replace("#", "")
            ) {
              swp.slideTo(i);
              return;
            }
          }
        };
      });

      //section used for small screen Dropdown
      const selectOurWorkPlace = document.querySelector("#OurWorkPlaceCat");
      if (selectOurWorkPlace) {
        selectOurWorkPlace.addEventListener("change", (e) => {
          let linkOurWorkPlace = e.target.value;
          for (var i = 0; i < slideArray.length; i++) {
            if (slideArray[i].dataset.customNavSlide == linkOurWorkPlace) {
              swp.slideTo(i);
              return;
            }
          }
        });
      }
    }
  });
})();
